module.exports = __webpack_public_path__ + "img/list-livedealer.5f740f93.webp";